import { normalizeAppLanguage } from "util/locale";

/**
 * UI chrome language for public survey widget.
 * Multilingual surveys follow visitor/channel language; otherwise use survey primary language.
 */
export function resolveSurveyInterfaceLanguage({
  multilingualEnabled = false,
  apiLanguage,
  primaryLanguage,
} = {}) {
  const primary = normalizeAppLanguage(primaryLanguage || "en");
  if (!multilingualEnabled) {
    return primary;
  }
  return normalizeAppLanguage(apiLanguage || primary);
}
